import axios from 'axios';

import {getAuthToken} from 'utils/localStorage';

export const getDefaultConfig = () => ({'Content-Type': 'application/json'});

export const getDefaultConfigWithToken = (token?: any) => {
  const config = getDefaultConfig();

  if (!token) {
    token = getAuthToken();
  }

  config['Authorization'] = `JWT ${token}`;

  return config;
};

export const post = (
  url,
  payload = {},
  headers?: {},
  noTransform?: boolean
) => {
  /*
    If `_transform` is passed in the GET params the BE will transform the snake_case keys into camelCase.
    *NOTE* If you want to pass any other GET params to a POST request in future - rework this sdk to accept such argument.

    If you don't want to pass `_transform` in the request use `noTransform=true` when calling this sdk.

    If you want to pass any different headers from the default ones (`getDefaultConfigWithToken`)
    pass `headers={<yourHeadersHere>}`.

    *NOTE* This will remove the default ones. If you want them in your request you should pass them *explicitly*.
    *NOTE* Be aware with the authentication headers!
      e.g. If we pass our JWT auth header when uploading file in s3 the call will fail.
  */
  let params: any = {_transform: true};

  if (noTransform) {
    params = {};
  }

  return axios.post(url, payload, {
    params,
    headers: headers || getDefaultConfigWithToken()
  });
};

export const get = (url, params = {}, headers?: {}, noTransform?: boolean) => {
  /*
    If `_tranform` is passed in the GET params the BE will transform the snake_case keys into camelCase.

    If you don't want to pass `_transform` in the request use `noTransform=true` when calling this sdk.

    If you want to pass any different headers from the default ones (`getDefaultConfigWithToken`)
    pass `headers={<yourHeadersHere>}`.
    *NOTE* This will remove the default ones. If you want them in your request you should pass them *explicitly*.
  */
  let paramsWithTransform: any = {_transform: true};

  if (noTransform) {
    paramsWithTransform = {};
  }

  return axios.get(url, {
    params: {...paramsWithTransform, ...params},
    headers: headers || getDefaultConfigWithToken()
  });
};

export const requestBlob = (
  url,
  params = {},
  headers?: {},
  noTransform?: boolean
) => {
  /*
    This sdk works like the `get` one from above with the difference it passes `responseType='blob'` to the axios.get
  */
  let paramsWithTransform: any = {_transform: true};

  if (noTransform) {
    paramsWithTransform = {};
  }

  return axios.get(url, {
    params: {...paramsWithTransform, ...params},
    headers: headers || getDefaultConfigWithToken(),
    responseType: 'blob'
  });
};
